export default function(element, display = "inherit") {
  element.setAttribute("style", `display: ${display}`);
}
